import { render, staticRenderFns } from "./detailsLamp.vue?vue&type=template&id=8b172a96&scoped=true"
import script from "./detailsLamp.vue?vue&type=script&lang=js"
export * from "./detailsLamp.vue?vue&type=script&lang=js"
import style0 from "./detailsLamp.vue?vue&type=style&index=0&id=8b172a96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b172a96",
  null
  
)

export default component.exports